import natoCover from "../assets/Zines/nato.png";
import natoPdf from "../assets/Zines/nato-zine.pdf";
import votingGuideCover from "../assets/Zines/voting-guide.png";
import votingGuidePdf from "../assets/Zines/voting-guide-zine.pdf";
import divestmentResearchCover from "../assets/Zines/divestment-research.png";
import divestmentResearchPdf from "../assets/Zines/divestment-research.pdf";
import fundsGenocideCover from "../assets/Zines/how-detroit-funds-genocide.png";
import fundsGenocidePdf from "../assets/Zines/how-detroit-funds-genocide.pdf";
import livingThroughGenocideCover from "../assets/Zines/living-through-genocide.png";
import livingThroughGenocidePdf from "../assets/Zines/living-through-genocide.pdf";
import generalElectionCover from "../assets/Zines/general-election-2025.png";
import generalElectionPdf from "../assets/Zines/general-election-2025.pdf";
import noMoreWarCover from "../assets/Zines/no-more-war.png";
import noMoreWarPdf from "../assets/Zines/no-more-war.pdf";
import noPrideCover from "../assets/Zines/no-pride-in-genocide.png";
import noPridePdf from "../assets/Zines/no-pride-in-genocide.pdf";
import warProfiteersCover from "../assets/Zines/war-profiteers.png";
import warProfiteersPdf from "../assets/Zines/war-profiteers.pdf";

export const zinesTitle = "Zines";

/* Visually hidden: the current zines need a heading between the page title and
   the card titles, or the outline jumps h1 to h3. */
export const zinesCurrentHeading = "Latest zines";

export const zinesArchiveHeading = "Archive";

/** Badge shown on archived zine cards. */
export const zineArchivedLabel = "Archived";

export interface Zine {
  id: string;
  title: string;
  /** Markdown; empty string if none. */
  description: string;
  /** Imported cover image URL. */
  cover: string;
  /** Imported PDF URL. */
  pdf: string;
  /**
   * Still published, but tied to a moment that has passed — an election that
   * has been held, a campaign that has ended. Archived zines are grouped
   * separately so they are not mistaken for current material.
   */
  archived?: boolean;
}

export const zines: Zine[] = [
  {
    id: "nato",
    title: "All About NATO",
    description: "An introduction to the alliance — what NATO is, and why we organize against it.",
    cover: natoCover,
    pdf: natoPdf,
    archived: true,
  },
  {
    id: "voting-guide",
    title: "Detroit Mayoral Election Voting Guide",
    // The zine's own cover disclaimer stresses this is not an endorsement.
    description:
      "Our guide to the candidates in the Detroit mayoral primary. Not an endorsement — a breakdown of where each campaign stands.",
    cover: votingGuideCover,
    pdf: votingGuidePdf,
    archived: true,
  },
  {
    id: "divestment-research",
    title: "Detroit Divest",
    description: "Understanding the research behind the Detroit Divest movement.",
    cover: divestmentResearchCover,
    pdf: divestmentResearchPdf,
  },
  {
    id: "how-detroit-funds-genocide",
    title: "How Detroit Funds Genocide",
    description:
      "How Detroit spent $145 million directly funding genocide — and the BDS contracts behind it.",
    cover: fundsGenocideCover,
    pdf: fundsGenocidePdf,
  },
  {
    id: "living-through-genocide",
    title: "Living Through a Genocide",
    description: "Impacts on mental health, and how trauma shapes the lives of survivors.",
    cover: livingThroughGenocideCover,
    pdf: livingThroughGenocidePdf,
  },
  {
    id: "general-election-2025",
    title: "Mayoral & City Council Voter Guide",
    // Distinct from the primary guide above — this one covers the general.
    description:
      "What you need to know as pro-Palestine and anti-war voters, for the 2025 Detroit general election.",
    cover: generalElectionCover,
    pdf: generalElectionPdf,
    archived: true,
  },
  {
    id: "no-more-war",
    title: "No More War!",
    description: "An introduction to the Detroit Anti-War Committee’s campaign for divestment.",
    cover: noMoreWarCover,
    pdf: noMoreWarPdf,
    archived: true,
  },
  {
    id: "no-pride-in-genocide",
    title: "No Pride in Genocide",
    description: "On pinkwashing, and how it plays out in Detroit.",
    cover: noPrideCover,
    pdf: noPridePdf,
    archived: true,
  },
  {
    id: "war-profiteers",
    title: "Who Profits From Genocide?",
    description:
      "War profiteers in Michigan, and how war and military spending are made profitable regardless of the public’s interest.",
    cover: warProfiteersCover,
    pdf: warProfiteersPdf,
    archived: true,
  },
];
